import React from 'react';
import { Alert, Button, Modal, Spinner, Table } from 'react-bootstrap';
import { MODO_DEFENSA } from '../../common/config-ingreso-manual';
import { montoSinFormato, nombreDe, normalizaPatente, porcentajeConvenio } from '../../common/ingreso-manual';

const Fila = ({ etiqueta, valor }) => (
    <tr>
        <th style={{ width: '34%' }} className="text-muted">{etiqueta}</th>
        <td>{valor || '—'}</td>
    </tr>
);

// Lo que no se informó se muestra como "No informado".
const persona = (rut, nombre) => [rut, nombre].filter(Boolean).join(' · ') || 'No informado';
const monto = (valor) => (valor ? '$ ' + Number(valor).toLocaleString('es-CL') : '—');
const fecha = (iso) => (iso ? iso.split('-').reverse().join('-') : '');

// modoEdicion: { idCaso } si se está actualizando un caso existente (cambia el título y el botón).
// modo: 'RECUPERO' o 'DEFENSA' (cartas inter cía), que muestra los datos de la carta en lugar del costo, la provisión y el abogado.
const ResumenModal = ({ show, valores, catalogos, guardando, error, onVolver, onConfirmar, modoEdicion, modo }) => {

    if (!valores) return null;

    return (
        <Modal show={show} onHide={guardando ? undefined : onVolver} size="lg" backdrop="static" centered>
            <Modal.Header>
                <Modal.Title as="h5">
                    {modoEdicion
                        ? `Revisar actualización — Caso ${modoEdicion.idCaso}`
                        : (modo === MODO_DEFENSA ? 'Revisar ingreso — Cartas inter cía' : 'Revisar ingreso — Recupero Inter Cía')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error ? <Alert variant="danger">{error}</Alert> : null}
                <Table size="sm" responsive>
                    <tbody>
                        <Fila etiqueta="Siniestro / patente" valor={`${valores.siniestro} / ${normalizaPatente(valores.patente)}`} />
                        <Fila etiqueta="Fechas" valor={`siniestro ${fecha(valores.fechaSiniestro)} · denuncio ${fecha(valores.fechaDenuncio)}`} />
                        <Fila etiqueta="Tipo de siniestro" valor={nombreDe(catalogos.tiposSiniestro, valores.tipoSiniestro)} />
                        {valores.causal ? <Fila etiqueta="Causal" valor={nombreDe(catalogos.causales, valores.causal)} /> : null}
                        {valores.poliza || valores.itemPoliza || valores.vigenciaDesde ? (
                            <Fila etiqueta="Póliza"
                                valor={[
                                    valores.poliza,
                                    valores.itemPoliza ? `ítem ${valores.itemPoliza}` : '',
                                    valores.vigenciaDesde ? `vigencia ${fecha(valores.vigenciaDesde)} a ${fecha(valores.vigenciaHasta)}` : ''
                                ].filter(Boolean).join(' · ')} />
                        ) : null}
                        {valores.colorVehiculo || valores.usoVehiculo ? (
                            <Fila etiqueta="Vehículo"
                                valor={[
                                    valores.colorVehiculo ? `color ${nombreDe(catalogos.colores, valores.colorVehiculo)}` : '',
                                    valores.usoVehiculo ? `uso ${nombreDe(catalogos.usos, valores.usoVehiculo)}` : ''
                                ].filter(Boolean).join(' · ')} />
                        ) : null}
                        <Fila etiqueta="Asegurado" valor={persona(valores.aseRut, valores.aseNombre)} />
                        <Fila etiqueta="Tercero"
                            valor={persona(valores.terRut, valores.terNombre) + (valores.terPatente ? ' · patente ' + normalizaPatente(valores.terPatente) : '')} />
                        <Fila etiqueta="Compañía del tercero"
                            valor={[
                                valores.idCiaImplicado ? nombreDe(catalogos.companias, valores.idCiaImplicado) : '',
                                valores.siniestroIM ? `siniestro N° ${valores.siniestroIM}` : ''
                            ].filter(Boolean).join(' · ') || 'No informada'} />
                        {valores.conRut ? <Fila etiqueta="Conductor" valor={persona(valores.conRut, valores.conNombre)} /> : null}
                        {modo === MODO_DEFENSA ? (
                            <React.Fragment>
                                <Fila etiqueta="Valor neto solicitado (CLP)" valor={monto(montoSinFormato(valores.costo))} />
                                <Fila etiqueta="Monto a pagar (CLP)"
                                    valor={`${monto(montoSinFormato(valores.montoPagar))}${porcentajeConvenio(valores.costo, valores.montoPagar) !== '' ? ` · convenio ${porcentajeConvenio(valores.costo, valores.montoPagar)} %` : ''}`} />
                                <Fila etiqueta="Recepción de la carta" valor={fecha(valores.fechaRecepcionCarta)} />
                                {valores.notasPreAnalisis ? <Fila etiqueta="Notas pre-análisis" valor={valores.notasPreAnalisis} /> : null}
                                <Fila etiqueta="Carta de cobro"
                                    valor={valores.cartaArchivo ? valores.cartaArchivo.name : (modoEdicion && modoEdicion.tieneCarta ? 'Se mantiene la carta adjunta' : 'Sin carta adjunta')} />
                                <Fila etiqueta="Responsable" valor="Usted (quien ingresa el caso)" />
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Fila etiqueta="Costo (CLP)" valor={monto(valores.costo)} />
                                <Fila etiqueta="Provisión (CLP)" valor={monto(valores.provision)} />
                                <Fila etiqueta="Abogado responsable" valor={nombreDe(catalogos.responsables, valores.idResponsable)} />
                            </React.Fragment>
                        )}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onVolver} disabled={guardando}>Volver</Button>
                <Button variant="success" onClick={onConfirmar} disabled={guardando}>
                    {guardando
                        ? <span><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> {modoEdicion ? 'Actualizando...' : 'Ingresando...'}</span>
                        : (modoEdicion ? 'Confirmar actualización' : 'Confirmar ingreso')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResumenModal;
